export const parseNumber = (value?: string | null): number | undefined => {
    if (value == null) {
        return undefined;
    }

    const result = Number(value);

    return Number.isFinite(result) ? result : undefined;
};
